/**
 * Frontend subject catalog.
 *
 * Loads from /api/subjects on first request and caches in module scope so
 * every selector across the app shares the same data without an extra
 * fetch per component.
 *
 * Backend source of truth: /app/backend/subjects_catalog.py
 */
import axios from 'axios';
import {
    BarChart3,
    TrendingUp,
    Globe,
    Brain,
    BookOpen,
    Users,
    BookText,
} from 'lucide-react';

const ICON_MAP = {
    BarChart3,
    TrendingUp,
    Globe,
    Brain,
    BookOpen,
    Users,
    BookText,
};

export const LEVELS = [
    { id: 'AS', name: 'AS Level' },
    { id: 'IAL', name: 'IAL (A2)' },
];

let _catalog = null;
let _inflight = null;

/**
 * Fetch the subjects catalog once and cache it. Returns the catalog array.
 * Each subject = { id, name, icon, levels: ['AS','IAL'], units: {AS:[…], IAL:[…]} }
 */
export async function loadSubjects() {
    if (_catalog) return _catalog;
    if (_inflight) return _inflight;
    _inflight = axios
        .get('/api/subjects')
        .then((r) => {
            _catalog = r.data || [];
            _inflight = null;
            return _catalog;
        })
        .catch(() => {
            _inflight = null;
            // Fallback to the original 3 so the app never breaks if the
            // catalog endpoint is unreachable.
            _catalog = [
                { id: 'business', name: 'Business', icon: 'BarChart3', levels: ['AS', 'IAL'], units: { AS: [], IAL: [] } },
                { id: 'economics', name: 'Economics', icon: 'TrendingUp', levels: ['AS', 'IAL'], units: { AS: [], IAL: [] } },
                { id: 'geography', name: 'Geography', icon: 'Globe', levels: ['AS', 'IAL'], units: { AS: [], IAL: [] } },
            ];
            return _catalog;
        });
    return _inflight;
}

export function getSubjectIcon(iconName) {
    return ICON_MAP[iconName] || BookOpen;
}

export function unitsFor(subject, level) {
    if (!subject || !level) return [];
    return subject.units?.[level] || [];
}
